<template>
  <iframe
    src="/reports/schedules/"
    style="width:100%;height:100%;border:none"
  ></iframe>
</template>

<script>
export default {
  name: 'Scheduler'
}
</script>

<style scoped>
iframe {
  border-width: 0;
}
</style>
